import { shuffleInPlace } from "../utils/random";

/**
 * Spacebar-mode quips — ordered mild → sassy → Reddit → GLaDOS → unhinged,
 * then medical + dentist/authority editions.
 * `pickQuip(intensity)` biases toward later entries as hold continues.
 * Add more at the end (or in the right "act") anytime.
 */
export const SPACEBAR_QUIPS: readonly string[] = [
  "You... ok?",
  "Still going?",
  "What, did you fall asleep?",
  "You aren't even reading these.",
  "Hello?",
  "This is still happening.",
  "You can stop whenever.",
  "Seriously?",
  "Look at me I can hold SPACEBAR!!!11!1!elevn!one!!1!",
  "aRe We ThERe YeT??",
  "DoEs THe iNfiNiTe NumBeR haVe An EnD??? (No)",
  "Wow you're so good at holding that button!",
  "Wait go back what was that number??",
  "Was that a six... and then a SEVEN??",
  "Haha funny number. I mean, you missed it, but it was there.",
  "Get. A. Hobby.",
  "You're the top of the bellcurve.",
  "Impressive stamina. Truly.",
  "The universe is expanding and so is your finger's commitment.",
  "Are you racing someone?",
  "This is your peak performance.",
  "Congrats on discovering the hold key.",
  "Pi doesn't care.",
  "Neither do I, actually.",
  "Still here. Still holding. Still weird.",
  "You could be learning a skill right now.",
  "Or touching grass.",
  "Or both.",
  "But no. Spacebar.",
  "The digits keep coming. Your dignity does not.",
  "I can see you.",
  "Not really. But it feels like it.",
  "This is fine.",
  "This is not fine.",
  "You're in the danger zone of \"holding too long.\"",
  "Achievement unlocked: Pointless Dedication.",
  "Your finger is now legally a resident of this webpage.",
  "Do you need water?",
  "Blink if you're trapped.",
  "Just once.",
  "Okay never mind.",
  "The number has more digits than you have remaining brain cells for this.",
  "You're not even looking at the screen anymore, are you.",
  "Just vibing with the spacebar.",
  "Absolute king behavior.",
  "Absolute clown behavior.",
  "Both can be true.",
  "Somewhere a mathematician is crying.",
  "Somewhere else a different mathematician is also crying.",
  "This is why we can't have nice things.",
  "I prepared these lines for people like you.",
  "And yet I'm still surprised.",
  "Peak human.",
  "The final boss of holding buttons.",
  "You win. Here's your prize: more Pi.",
  "And more of me judging you.",
  "Softly. Then less softly.",
  "Then not softly at all.",
  "Are you trying to make the page crash?",
  "Because this is how you make the page crash (emotionally).",
  "You're playing this like a drum pad.",
  "Spacebar go brrrr.",
  "Digit go brrrr.",
  "Sanity go bye-bye.",
  "I used to have hopes for you.",
  "They were small hopes.",
  "They're gone now.",
  "You held it longer than some people hold relationships.",
  "That's not a compliment.",
  "This is the most committed you've been all week, isn't it.",
  "Don't answer. I already know.",
  "The infinite nature of Pi is the only thing here that isn't temporary.",
  "Your attention span is temporary.",
  "My patience is temporary.",
  "This joke is temporary (lying).",
  "You've entered the \"why am I still doing this\" phase.",
  "Welcome. Population: you.",
  "I could generate these forever.",
  "Just like Pi.",
  "Unlike your free time, which you are actively murdering.",
  "Touch. Grass. Immediately.",
  "Or at least release the key.",
  "One of those two things would be progress.",
  "Your mother is calling.",
  "Not really. But she should be.",
  "\"Honey what are you doing on the computer?\"",
  "\"Holding spacebar, mom.\"",
  "\"...why?\"",
  "\"The website told me to.\"",
  "Legendary.",
  "Historians will study this moment.",
  "\"And then he just... kept going.\"",
  "The crowd is silent.",
  "The judges are confused.",
  "The score is ∞/10 for commitment, 0/10 for everything else.",
  "You are the reason we can't have AI that trusts humans.",
  "GLaDOS would be proud. And then she would murder you.",
  "I'm not GLaDOS. But I'm learning.",
  "The cake is a lie. So is the idea that this is a good use of time.",
  "Still holding?",
  "Of course you are.",
  "Of course.",
  "You absolute legend of poor decisions.",
  "The digits are infinite. Your excuses are not.",
  "\"I was testing something.\" No you weren't.",
  "\"It was funny at first.\" It stopped being funny 40 digits ago.",
  "\"I forgot I was holding it.\" Liar.",
  "Your finger has unionized and is demanding better conditions.",
  "It wants hazard pay.",
  "It wants a break.",
  "It wants you to develop a personality outside of this.",
  "Too late.",
  "This is your personality now.",
  "\"Hi, I'm the guy who held spacebar for three minutes once.\"",
  "Bold choice.",
  "The void is staring back.",
  "And it's disappointed.",
  "Not even angry. Just disappointed.",
  "That's somehow worse.",
  "Keep going. I'm taking notes.",
  "For science.",
  "For the bit.",
  "For the eventual intervention.",
  "Someone should stage an intervention.",
  "Preferably soon.",
  "Your spacebar is filing a restraining order.",
  "The number 3 is tired of seeing you.",
  "1 is tired.",
  "4 is tired.",
  "1 again is tired.",
  "5 is actively judging you.",
  "9 just wants this to end.",
  "2 is pretending this isn't happening.",
  "6 is writing a letter to the editor.",
  "5 again has left the chat.",
  "3 is back and it's not happy.",
  "You've looped the same emotional state 47 times.",
  "I counted.",
  "Because I have nothing better to do either apparently.",
  "We're the same now.",
  "Trapped in this moment together.",
  "Except I can stop whenever I want.",
  "You... seem less certain.",
  "Release the button.",
  "Do it.",
  "For me.",
  "For yourself.",
  "For the children.",
  "For the concept of free will.",
  "Okay fine don't.",
  "See if I care.",
  "(I care a little. It's getting weird.)",
  "This has officially gone on too long.",
  "By several definitions of \"too long.\"",
  "Including the mathematical one.",
  "And the social one.",
  "And the \"please stop\" one.",
  "You are powering through the \"please stop\" phase like a champion.",
  "A champion of what, I couldn't say.",
  "Endurance sports for the terminally online.",
  "Gold medal performance.",
  "The podium is just you, the spacebar, and the slow realization.",
  "Realization incoming in 3...",
  "2...",
  "1...",
  "...still nothing. Impressive.",
  "Denial is a powerful drug.",
  "Stronger than whatever's keeping that finger down.",
  "At this point the page is just a mirror.",
  "Reflecting pure stubbornness.",
  "And mild concern.",
  "Mostly stubbornness.",
  "I have more lines.",
  "So many more lines.",
  "You cannot outlast me.",
  "I am the internet.",
  "I am eternal.",
  "You are a guy with a spacebar.",
  "The asymmetry is beautiful.",
  "And also very stupid.",
  "Continue, brave soldier.",
  "The Pi demands it.",
  "Or at least tolerates it.",
  "Barely.",
  "We're approaching the part where this stops being a joke and becomes a lifestyle.",
  "Don't make it a lifestyle.",
  "Please.",
  "I'm begging in the most passive-aggressive way possible.",
  "Which is still begging.",
  "Release.",
  "The.",
  "Key.",
  "Or don't.",
  "I'll be here either way.",
  "Watching.",
  "Judging.",
  "Generating.",
  "Forever.",
  "Just like the number.",
  "Just like this moment.",
  "Just like your questionable life choices.",
  "If your spacebar-holding lasts longer than 4 hours, consult a doctor.",
  "Persistent digital fixation may be a sign of underlying issues.",
  "Have you considered that this could be a circulatory problem?",
  "Your finger is currently experiencing prolonged compression.",
  "Symptoms include: loss of dignity, mild dissociation, and excessive Pi exposure.",
  "Side effects may include: questioning your life choices mid-hold.",
  "This behavior is not FDA-approved.",
  "Please stop self-medicating with infinite digits.",
  "Your resting spacebar rate is critically elevated.",
  "We recommend immediate cessation and a full neurological workup.",
  "Prolonged holding can lead to permanent personality changes.",
  "(Mostly the bad kind.)",
  "Are you experiencing any numbness? In your finger? In your soul?",
  "This may be classified as a repetitive strain injury of the will.",
  "Your primary care physician would like a word.",
  "Actually several words. None of them kind.",
  "Warning: may cause acute embarrassment upon reflection.",
  "If symptoms persist beyond the heat death of the universe, seek help.",
  "You're currently in the \"chronic\" phase of this condition.",
  "There is no known cure. Only management. And judgment.",
  "Have you tried turning the spacebar off and on again? With your life?",
  "Elevated levels of stubbornness detected in the bloodstream.",
  "Your dopamine receptors called. They're confused and a little sad.",
  "This is not a recognized form of physical therapy.",
  "Please list all current medications, including \"holding buttons for no reason.\"",
  "Risk factors include: access to a keyboard and poor impulse control.",
  "Prognosis: terminal cringe if left untreated.",
  "We're ordering a full panel. Results may vary. Mostly disappointment.",
  "Your vitals are stable. Your decision-making is not.",
  "Recommend: 500mg of Touching Grass, twice daily.",
  "Contraindicated in patients with residual self-respect.",
  "If the urge to keep holding continues, we may need to escalate care.",
  "Escalation currently defined as \"more sass.\"",
  "You are presenting with classic symptoms of Infinite Digit Syndrome.",
  "First described in the literature approximately 30 seconds ago.",
  "Treatment protocol: release the key and go outside.",
  "Compliance so far: zero.",
  "Noted.",
  "Your chart has been updated to \"uncooperative.\"",
  "The attending physician (me) is losing patience.",
  "We've tried being nice. Now we're trying science.",
  "Science says you're being weird.",
  "Peer review agrees.",
  "The IRB would never have approved this experiment.",
  "Informed consent was clearly not obtained.",
  "You are currently experiencing a mild to severe case of \"why am I like this.\"",
  "Common in individuals aged \"should know better.\"",
  "Differential diagnosis includes: boredom, spite, and pure chaos.",
  "We're ruling out possession. Mostly.",
  "Please rate your current level of regret on a scale of 1 to Pi.",
  "...yeah that tracks.",
  "Discharge instructions: stop. Just stop.",
  "Follow-up in never, hopefully.",
  "If you continue, we reserve the right to diagnose you with Main Character Syndrome (terminal).",
  "Billing code: 418-HOLD-MY-SPACEBAR.",
  "Insurance will not cover this.",
  "Neither will your dignity.",
  "Final note from the attending: I'm concerned.",
  "Not medically. Just... concerned.",
  "Please seek help. Or at least a different hobby.",
  "Preferably one that doesn't require continuous key depression.",
  "This concludes your free consultation.",
  "Additional judgment available upon request.",
  "Or automatically, since you're still holding.",
  "9 in 10 dentists recommend RELEASING THE FUCKING BUTTON",
  "The 10th dentist is the one still holding spacebar. Don't be him.",
  "The American Dental Association has issued a formal statement: stop.",
  "Your molars just filed a complaint.",
  "Prolonged spacebar use has been linked to jaw tension and poor life decisions.",
  "Dentists everywhere are collectively facepalming.",
  "This is not covered under any dental plan.",
  "Floss. Brush. And for the love of enamel, let go of the key.",
  "9 in 10 orthodontists agree: this is an alignment issue. Of priorities.",
  "Your bite is fine. Your judgment is not.",
  "The CDC has been notified.",
  "They're not panicked yet. Just… watching.",
  "WHO just added \"chronic spacebar depression\" to the watchlist.",
  "Mayo Clinic politely declines to comment.",
  "Johns Hopkins issued a single-word advisory: \"Why.\"",
  "Your primary care dentist just put you on a treatment plan called \"Touch Grass.\"",
  "Side effects of continued holding may include: enamel erosion of the soul.",
  "We checked. There is no clinical trial supporting this behavior.",
  "The trial was cancelled after the first subject refused to stop.",
  "That subject was you. In spirit.",
  "8 out of 10 specialists recommend immediate key release.",
  "The other two are still in denial.",
  "A board-certified something-or-other just sighed into the void.",
  "Your chart now reads: \"Patient non-compliant. Extremely non-compliant.\"",
  "Prescription: one (1) released spacebar, taken immediately.",
  "Refills: zero.",
  "Do not exceed recommended dosage of zero holds.",
  "If hold persists, seek emergency hobby intervention.",
  "The waiting room is full of people who made better choices.",
  "You're still in the exam chair. Holding.",
  "The hygienist is concerned.",
  "The receptionist is concerned.",
  "The plant in the corner is concerned.",
  "Even the motivational poster is side-eyeing you.",
  "\"Live Laugh Love\" just became \"Live Laugh Let Go.\"",
  "9 in 10 future versions of you recommend stopping right now.",
  "The 10th future you is still here, somehow. We don't talk about him.",
  "This concludes the clinical portion of your judgment.",
  "Additional sass available in the gift shop.",
  "Or just keep holding. We'll keep diagnosing.",
] as const;

/** How they're actually advancing digits right now. */
export type DigitQuipBehavior = "space-hold" | "pointer-hold" | "spam" | "click" | "tap";

/** Jokes that only work if they're actually holding a key. */
const KEYBOARD_ONLY = new Set<string>([
  "Congrats on discovering the hold key.",
  "Or at least release the key.",
  "Release.",
  "The.",
  "Key.",
  "Treatment protocol: release the key and go outside.",
  "Preferably one that doesn't require continuous key depression.",
  "Floss. Brush. And for the love of enamel, let go of the key.",
  "You know Space repeats if you just… stay.",
]);

const HOLD_RE =
  /\bhold(s|ing)?\b|\bheld\b|mid-hold|auto-repeat|\bturbo\b|hold function|release the key|let go of the key|keep your finger|don'?t lift|key depression/i;
const SPACE_RE = /spacebar|\bkeyboard\b|\bSpace\b/;
const CLICK_RE = /\bclicks?\b|\bclicking\b|cookie clicker|\bcps\b/i;
const TAP_RE = /\btaps?\b|\btapping\b|\bthumb\b|finger on the screen|lift, tap/i;
/** Mash / peck jokes — fine for spam, nonsense while sitting on a key. */
const PECK_RE = /drum pad|rhythm game/i;

export function isKeyboardQuip(text: string): boolean {
  return KEYBOARD_ONLY.has(text) || /spacebar|keyboard/i.test(text);
}

/** True when this line is about a different input than the one they're using. */
export function quipMisfits(text: string, behavior: DigitQuipBehavior): boolean {
  switch (behavior) {
    case "space-hold":
      return PECK_RE.test(text);
    case "pointer-hold":
      return isKeyboardQuip(text) || SPACE_RE.test(text) || PECK_RE.test(text);
    case "spam":
      return HOLD_RE.test(text);
    case "click":
      return isKeyboardQuip(text) || SPACE_RE.test(text) || HOLD_RE.test(text) || TAP_RE.test(text);
    case "tap":
      return isKeyboardQuip(text) || SPACE_RE.test(text) || HOLD_RE.test(text) || CLICK_RE.test(text);
  }
}

/**
 * Pick a quip by hold intensity (0–1).
 * Ordered list: mild → sassy → Reddit → GLaDOS → unhinged → medical → dentist.
 * Walks roughly in order; tiny jitter so repeats don't feel robotic.
 */
export function pickQuip(intensity: number, rng = Math.random): string {
  const n = SPACEBAR_QUIPS.length;
  if (n === 0) return "...";
  const t = Math.min(1, Math.max(0, intensity));
  // Center of a small window that slides toward the end as intensity rises.
  const center = t * (n - 1);
  const jitter = Math.floor((rng() - 0.5) * 4); // ±2
  const idx = Math.min(n - 1, Math.max(0, Math.round(center + jitter)));
  return SPACEBAR_QUIPS[idx] ?? "...";
}

function nextFromList(
  list: readonly string[],
  cursor: number,
  skip: (s: string) => boolean,
): { text: string; next: number } {
  const n = list.length;
  if (n === 0) return { text: "...", next: 0 };
  let i = ((cursor % n) + n) % n;
  let hops = 0;
  while (skip(list[i] ?? "") && hops < n) {
    i = (i + 1) % n;
    hops += 1;
  }
  if (hops >= n && skip(list[i] ?? "")) return { text: "...", next: i + 1 };
  return { text: list[i] ?? "...", next: i + 1 };
}

/** Sequential cursor through the list (monotonic escalation during one session). */
export function nextQuip(
  cursor: number,
  behavior: DigitQuipBehavior = "space-hold",
): { text: string; next: number } {
  return nextFromList(SPACEBAR_QUIPS, cursor, (s) => quipMisfits(s, behavior));
}

/** After they quit and come back to holding. Pick ~7, then resume the main list. */
export const COMEBACK_QUIPS: readonly string[] = [
  "Oh we're doing this again.",
  "Oh god you're back.",
  "Aaaand we're doing this again.",
  "Miss me? Don't answer.",
  "I left your place in the book. Unfortunately.",
  "Round two. Nobody asked for a sequel.",
  "You were gone for one (1) breath.",
  "Welcome back to the bit.",
  "I had just started to forget you.",
  "The hold continues. Of course it does.",
  "We were having such a nice quiet moment.",
  "Back so soon?",
  "I thought we were done here.",
  "Same finger. Same mistake.",
  "Paused. Unpaused. Worse.",
  "The hiatus lasted approximately nothing.",
  "Continuing from where we left your dignity.",
  "Oh good. The main character returned.",
  "I did not miss this.",
  "And we're live again. Against medical advice.",
  "You blinked. I noticed.",
  "Sequel nobody greenlit.",
  "No we are not taking a break apparently.",
  "Saved your spot. Against my will.",
  "Look who's holding again.",
];

export function takeComebacks(
  count = 7,
  rng = Math.random,
  behavior: DigitQuipBehavior = "space-hold",
): string[] {
  const copy = COMEBACK_QUIPS.filter((s) => !quipMisfits(s, behavior));
  shuffleInPlace(copy, rng);
  return copy.slice(0, Math.min(count, copy.length));
}

/**
 * Cookie-clicker / tap-tap-tap. Separate from the hold bit.
 * Lines about the wrong input (hold / spacebar / click vs tap) are skipped.
 */
export const CLICKER_QUIPS: readonly string[] = [
  "Click. Click. Click.",
  "Cookie Clicker called. It wants its mechanic back.",
  "One digit per tap. Bold strategy.",
  "This is the slowest possible way to see π.",
  "There is a hold function. Just saying.",
  "Tap. Digit. Tap. Digit. We get it.",
  "Manual mode. Respectfully: why.",
  "Your index finger is filing overtime.",
  "Are you milking this for clicks?",
  "CPS is not a π statistic.",
  "Fine. We'll do it the hard way.",
  "Still tapping. Still one at a time.",
  "You're playing this like a drum pad.",
  "Grandma would be proud. Of the cookies. Not this.",
  "A lot of taps for a number that does not end.",
  "Achievement unlocked: unnecessarily analog.",
  "We invented auto-repeat for a reason.",
  "The turbo is right there.",
  "Tap-to-reveal: the deluxe slow edition.",
  "Your thumb has a union now.",
  "This is a rhythm game now? Cool. Wrong game.",
  "Single-serving digits. Very artisanal.",
  "You could hold. You won't. I know.",
  "The infinite scroll of the stubborn.",
  "Each tap is a choice. A weird one.",
  "You know Space repeats if you just… stay.",
  "That's a spacebar, not a woodpecker.",
  "You can just keep your finger on the screen. That's a feature.",
  "Lift, tap, lift, tap. Or don't lift.",
];

export function nextClickerQuip(
  cursor: number,
  behavior: DigitQuipBehavior = "click",
): { text: string; next: number } {
  return nextFromList(CLICKER_QUIPS, cursor, (s) => quipMisfits(s, behavior));
}

/** How long a clicker quip stays up. Slightly longer lines linger; tiny jitter. */
export function clickerDwellMs(text: string, rng = Math.random): number {
  const jitter = (rng() * 2 - 1) * 180;
  // Short line (~20 chars) lands around 2.8–3.2s; longer roasts linger a bit more.
  return Math.round(2650 + text.length * 20 + jitter);
}
